import { render, staticRenderFns } from "./TelphoneNGWordsChart.vue?vue&type=template&id=1dfc0bed"
import script from "./TelphoneNGWordsChart.vue?vue&type=script&lang=js"
export * from "./TelphoneNGWordsChart.vue?vue&type=script&lang=js"
import style0 from "./TelphoneNGWordsChart.vue?vue&type=style&index=0&id=1dfc0bed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports